import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-uparrow",
  "use": "icon-uparrow-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-uparrow\">\n<g id=\"icon-uparrow_Frame 179305\" clip-path=\"url(#icon-uparrow_clip0_213_3963)\">\n<path id=\"icon-uparrow_Vector 1146\" d=\"M9 19L15.2929 12.7071C15.6834 12.3166 16.3166 12.3166 16.7071 12.7071L23 19\" stroke=\"#6F6F6F\" stroke-width=\"2\" stroke-linecap=\"round\" />\n</g>\n<defs>\n<clipPath id=\"icon-uparrow_clip0_213_3963\">\n<rect width=\"32\" height=\"32\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/uparrow.svg
// module id = c2y5
// module chunks = 102